import { createSlice } from '@reduxjs/toolkit';
import { logout, setCredentials } from './authSlice';

// Sales Incentives on the POS: the cached "incentive item" product set and a kill switch.
// Display only — nothing here takes part in pricing, tax or payment.
const initialState = { productIds: [], etag: null, checkedAt: 0, hidden: false };

const salesIncentivesSlice = createSlice({
  name: 'salesIncentives',
  initialState,
  reducers: {
    incentiveProductSetLoaded: (state, { payload }) => {
      state.productIds = payload.productIds;
      state.etag = payload.etag || null;
      state.checkedAt = payload.checkedAt;
    },
    // 304: the cached set is still current.
    incentiveProductSetUnchanged: (state, { payload }) => {
      state.checkedAt = payload.checkedAt;
    },
    // A 403 module_not_enabled / module_read_only: hide every incentive UI until the next login.
    incentivesHidden: (state) => {
      state.hidden = true;
      state.productIds = [];
      state.etag = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
    builder.addCase(setCredentials, () => initialState);
  },
});

export const { incentiveProductSetLoaded, incentiveProductSetUnchanged, incentivesHidden } = salesIncentivesSlice.actions;

// The POS shows incentives only when the organization has the module in full (terminal-selection payload).
export const selectIncentivesAccess = (state) =>
  state.auth?.organization?.modules?.sales_incentives === 'full' && !state.salesIncentives?.hidden;

export default salesIncentivesSlice.reducer;
